import { useEffect, useRef } from 'react';
import { datadogRum } from '@datadog/browser-rum-slim';

import { getHash } from 'shared/utils/getHash';
import { useSessionValue } from 'appLayer/auth';

import { MONITORING_TAGS } from 'constants/monitoring';
import { createHashedEmailChangeEvent } from './events';

export const useAnalyticsHashedEmail = () => {
  const session = useSessionValue();
  const email = session?.customer.email || null;
  const prevEmailRef = useRef<string | null>(null);

  useEffect(() => {
    if (email === prevEmailRef.current || !email) {
      return undefined;
    }

    let isMounted = true;

    getHash(email)
      .then((hashedCustomerEmail) => {
        if (isMounted) {
          createHashedEmailChangeEvent({ hashedCustomerEmail });

          prevEmailRef.current = email;
        }
      })
      .catch((error) => {
        const tags = {
          [MONITORING_TAGS.ANALYTICS]: true
        };
        datadogRum.addError(error, { tags });
      });

    return () => {
      isMounted = false;
    };
  }, [email]);
};
